import React, { Component } from 'react';
import classnames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen, faUser } from '@fortawesome/free-solid-svg-icons';

import './Module.css';

class Module extends Component {

  static defaultProps = {
    moduleName : "UNDEFINED",
    description : "UNDEFINED",
    moduleScript : "UNDEFINED",
    owner : "UNDEFINED",
    state : false,
    createdTime : "UNDEFINED",
    lastUpdatedTime : "UNDEFINED",
  }

  state = {
    expand : false,
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.expand !== nextProps.expand) {
      return true;
    }
    return false;
  }

  renderModuleState = (state) => {
    if (state) {
      return (
        <FontAwesomeIcon icon={faLockOpen} className="icon" />
      );
    }
    return (
      <FontAwesomeIcon icon={faLock} className="icon" />
    );
  }

  handleClickModule = (e) => {
    this.props.toggleExpand(this.props.id);
  }

  render() { 
    const { renderModuleState } = this;

    const { moduleName } = this.props;
    const { moduleScript } = this.props;
    const { description } = this.props;
    const { owner } = this.props;
    const { state } = this.props;
    const { createdTime } = this.props;
    const { lastUpdatedTime } = this.props;

    const renderedModuleState = renderModuleState(state); 

    const moduleClass = classnames('module','row', {
      'expand' : this.props.expand,
    })
    

    return (
      <div className={moduleClass}
        onClick={this.handleClickModule}>
        <div className="module-header">
          <div className="row">
            <div className="module-title-wrapper col-sm-10">
              <h5 className="module-name" > {moduleName} </h5>
              <p className="module-desc" > {description} </p>
            </div>
            <div className="module-state-wrapper col-sm-2">
              {renderedModuleState}
            </div>
          </div>
        </div>
        <div className="module-body"
          onClick={(e) => {e.stopPropagation()}}>
        {
          this.props.expand && (
            <div className="function-wrapper">
              <code>
                {moduleScript}
              </code> 
            </div>
          )
        }
        </div>
      </div>
    );
  }
}

export default Module;